import { render, staticRenderFns } from "./activistyCostAttribution.vue?vue&type=template&id=6d9b9070&scoped=true"
import script from "./activistyCostAttribution.vue?vue&type=script&lang=js"
export * from "./activistyCostAttribution.vue?vue&type=script&lang=js"
import style0 from "./activistyCostAttribution.vue?vue&type=style&index=0&id=6d9b9070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b9070",
  null
  
)

export default component.exports